import './App.css';
import Hero from './Components/Hero';

function App() {
  return (
    <div className="App">
      <Hero /> 
    </div>
  );
}

export default App;
